import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getDrivingData = createAsyncThunk(
  "api/drivingLicense?type=1",
  async (token) => {
    try {
      const response = await nodeinstance.get("/drivingLicense?type=1", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const DrivingDataSlice = createSlice({
  name: "Driving",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDrivingData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getDrivingData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getDrivingData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getDrivingData };
export default DrivingDataSlice.reducer;
